import './promotion.scss';
import React, { useEffect, useState } from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import AuthenticationDialogHandler from '../authentication-dialog-handler/authentication-dialog-handler';
import ImageGenerator from '../image-generator/image-generator';
import favListAdd from '../../assets/images/bookmark.svg';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import share from '../../assets/images/share.svg';
import voice from '../../assets/images/voice.svg';
import subTitle from '../../assets/images/subTitle.svg';
import time from '../../assets/images/time-circle.svg';
import { checkUserIsLogin } from '../../shared/services/user/user-service';
import Toast from '../toast/toast';
import imdb from '../../assets/images/imdb.svg';
import download from '../../assets/images/download.svg';
import arrowDown from '../../assets/images/arrow-Down.svg';
import play from '../../assets/images/play.svg';
import Dialog from '@material-ui/core/Dialog';
import ShareBottomSheet from '../bottom-sheet/share/share';
import Breadcrumb from '../breadcrumb/breadcrumb';
import { Rating } from '@material-ui/lab';
import Box from '@material-ui/core/Box';
import StarIcon from '@material-ui/icons/Star';
import { rateAProgram } from '../../shared/services/more-page/more-page-service';
import defaultLogo from '../../assets/images/bebin-logo.svg';
import { useConfigApp } from '../../shared/services/general/app-context';

const PromotionBg = styled.div`
  background-image: url(${props => props.image});
`;

export default function Promotion ({ data, handleAddToFav,typeProgram, movieDetail, buttonWatching }) {
	const [valueMovie, setValueMovie] = useState(movieDetail);
	const [openRegisterDialog, setOpenRegisterDialog] = useState(false);
	const [toastData, setToastData]                   = useState([]);
	const [shareDialog, setShareDialog]                   = useState(false);
	const [isRating, setIsRating]                   = useState(true);
	const [rateValue, setRateValue] = useState(null);
	const [logo, setLogo] = useState([]);
	const configApp = useConfigApp();
	const [showBoxDownload, setShowBoxDownload]                   = useState(false);
	const [downloadLinks,setDownloadLinks]				= useState([]);

	useEffect(() => {
		if (movieDetail?.userInteractions && movieDetail?.userInteractions?.rate && +movieDetail?.userInteractions?.rate > 0) {
			setRateValue(+movieDetail?.userInteractions?.rate)
		}

		if (movieDetail) {
			updateMediaId()
		}
	}, [movieDetail]);

	useEffect(() => {
		if (configApp) {
			const imgLogo = configApp?.logo ? require(`../../../src/assets/images/${configApp?.logo}`).default : defaultLogo;
			setLogo(imgLogo)
		}
	}, [configApp]);

	useEffect(() => {
		if (valueMovie?.userInteractions && valueMovie?.userInteractions?.rate && +valueMovie?.userInteractions?.rate > 0) {
			setRateValue(+valueMovie?.userInteractions?.rate)
		}
	}, [valueMovie]);

	const updateMediaId = () => {
		let downloadLinksObject = movieDetail?.metadata.downloadLinks || null;

		let temp = [];
		for (const key in downloadLinksObject) {
			if (Object.hasOwnProperty.call(downloadLinksObject, key)) {
				const link = downloadLinksObject[key];

				if (link !== '') {
					if (configApp && configApp?.media_id) {
						const updateLink = link.replace(/mediaId=[^&]*/, `mediaId=${configApp?.media_id}`);
						temp.push({ link: updateLink, size: key.replace(/_/g, '') });
					} else {
						console.error('configApp یا media_id موجود نیست.');
						temp.push({ link: link, size: key.replace(/_/g, '') });
					}
				}
			}
		}
		setDownloadLinks(temp);
	}

	const handleButtonWatching = () => {
		const showWatchingSeason = true;
		const selectedEpisode = 0;

		buttonWatching(showWatchingSeason, selectedEpisode);
	};

	const handleStatus = () => {
		if (movieDetail?.metadata.isFree !== false) {
			return <>
					{typeProgram === 'SERIES' ? (
						<div className="watching d-flex" onClick={() => handleButtonWatching()}>
							<Button variant={'text'} className="watch-movie w-100">
								<ImageGenerator src={play}
												isLazy={false}
												name={''} />
								<span>تماشا</span>
							</Button>
						</div>
					) : (
						<Link className="watching d-flex" to={`/player/${movieDetail.baseDetails.programId}`}>
							<Button variant={'text'} className="watch-movie w-100">

									<ImageGenerator src={play}
													isLazy={false}
													name={''} />
									<span>تماشا</span>
							</Button>
						</Link>
					)}


					 <Button variant={'text'}
						   className="watch-moviee">
					 </Button></>
		}


	};

	const renderProducedYear = () => {
		return (
			<div className="text-center">{movieDetail.tags?.[ 'production-year' ] ? <span>{movieDetail.tags[ 'production-year' ][ 0 ].bindings.year}</span> : null}</div>
		);
	};

	const renderCountry = () => {
		return (
			<div className="product-country">
				{
					movieDetail.tags[ 'country' ]?.map((item, index) => <div key={index}>{item?.value}<span className="pipe">،</span></div>)
				}
			</div>
		)
	}


	const renderGenres = (tags) => {
		return (
			<div>{tags ?
				<ul className="genre-list">
					{tags.map((item, index) => <li><Link to={`/t/genre/${item.id}/${typeProgram === 'SERIES' ? 'series' : 'movies'}`}
															   key={index}>{item.name}</Link></li>)}
				</ul>
				: null}</div>
		);
	};

	const updateInteraction = (newInteraction) => {
		setValueMovie((prevValueMovie) => ({
			...prevValueMovie, // نگه داشتن سایر قسمت‌های valueMovie
			userInteractions: {
				...prevValueMovie?.userInteractions, // نگه داشتن سایر مقادیر userInteractions
				...newInteraction.userInteractions,
			},
			programInteractions: {
				...prevValueMovie?.programInteraction, // نگه داشتن سایر مقادیر programInteraction
				...newInteraction.programInteractions,
			},
		}));
	};

	const rateUsers = () => {
		return (
			<div className="rate-users">
				<div className="rate">
					<span className="d-flex flex-column justify-content-center" style={{ alignItems: 'center' }}>
						<ImageGenerator src={logo} />
						<span style={{ color: '#8236FD' }}>
							{valueMovie?.programInteractions?.rate || 0}<span className="small">/5</span>
						</span>
					</span>
				</div>
			</div>
		);
	};

	const renderImdbRate = () => {
		if (movieDetail?.metadata?.imdbRate) {
			return (
				<>
					<div className="rate">
						<span className="d-flex flex-column justify-content-center" style={{ alignItems: 'center' }}>
							<ImageGenerator src={imdb} />
							<span style={{color: '#FFC63C'}}>
								{movieDetail?.metadata?.imdbRate}<span className="small">/10</span>
							</span>
						</span>
					</div>
				</>
			);
		}
		return null;
	};

	const ageRate = (ageRate) => {
		const ageList = {
			G: 'مناسب برای تمام سنین',
			PG: 'مناسب برای تمام سنین، توصیه به همراهی والدین',
			'PG-13': '<span>+13</span>مناسب برای سنین بالای 13 سال',
			R: '<span>+17</span>مناسب برای سنین بالای 17 سال',
			'NC-17': '<span>+18</span>مناسب برای سنین بالای 18 سال'
		};

		return ageList[ageRate] || '';
	};

	const handleRateHover = (event, newHover) => {
		// setHover(newHover !== -1 ? newHover : -1);
	};

	const rateProgram = (rateNumber) => {
		rateAProgram(movieDetail.baseDetails.programId, rateNumber).then((res)=> {
			if (res.status === 200) {
				const rawRate = parseFloat(res.data.data?.programInteraction?.rate);
				const formattedNumber = Math.floor(rawRate * 10) / 10;

				const interaction = {
					userInteractions: {
						disliked: res.data.data?.hasUserDisliked,
						liked: res.data.data?.hasUserLiked,
						rate: res.data.data?.userRate,
					},
					programInteractions: {
						dislikesCount: res.data.data?.programInteraction?.dislikesCount,
						likedPercent: res.data.data?.programInteraction?.likedPercent,
						likesCount: res.data.data?.programInteraction?.likesCount,
						rate: formattedNumber,
						rateCount: res.data.data?.programInteraction?.rateCount,
					}
				}
				updateInteraction(interaction)
			}
		})
	}

	const handleRateChange = (event, newValue) => {
		// setRateValue(newValue)
		if (!checkUserIsLogin() || !newValue) {
			setIsRating(false)
			return;
		}
		rateProgram(newValue)
	};

	const goToRegister = () => <Button variant={'text'}
									   onClick={() => setOpenRegisterDialog(true)}>
		<span>ورود/ ثبت‌نام</span>
	</Button>;

	useEffect(() => {
		const handleClickOutside = (e) => {
			const isInsideBox = e.target.closest(".download-box-details");
			const isPlayButton = e.target.closest(".play");
			if (!isInsideBox && !isPlayButton) {
				setShowBoxDownload(false);
			}
		};

		if (showBoxDownload) {
			document.addEventListener("click", handleClickOutside);
			return () => document.removeEventListener("click", handleClickOutside);
		}
	}, [showBoxDownload]);

	return (
		<>
			<div className="promotion-banner">
				{movieDetail?.baseDetails ? <>
					<div className='promotion-box'>
						<PromotionBg image={movieDetail?.metadata.posterImageUrl}
									 className='promotion-bg'></PromotionBg>
						<div className='promotion-info'>
							<div className="d-flex flex-column">
								{
									<Breadcrumb
										firstItem={typeProgram === 'MOVIE' ? { label: 'فیلم‌ها', path: '/' } : null}
										extraItem={{
											label: movieDetail?.metadata?.categories[0]?.name,
											path: `/t/category/${movieDetail?.metadata?.categories[0]?.id}/movies`,
										}}
										currentItem={movieDetail?.baseDetails?.title}
									/>
								}
								<div className="d-flex">
									<div className='right'>
										<div className='poster'>
											<ImageGenerator src={movieDetail?.baseDetails.image} />
										</div>
										<div className="meta">
											<div>
												<div>
													امتیاز شما
													{/*{*/}
													{/*	hover !== -1 && (*/}
													{/*		<span style={{marginRight: '5px', position: 'absolute'}}>*/}
													{/*			({hover} از 5)*/}
													{/*		</span>*/}
													{/*	)*/}
													{/*}*/}

												</div>
												<Box>
													<Rating
														style={{marginTop: '5px'}}
														name="customized-empty"
														// readOnly={value}
														value={rateValue}
														onChange={handleRateChange}
														onChangeActive={handleRateHover}
														icon={<StarIcon fontSize="inherit" style={{ color: '#FFC63C' }} />}
														emptyIcon={<StarBorderIcon fontSize="inherit" style={{ color: '#FFC63C' }} />}
													/>
													{rateValue !== null && <Box>
														<span>
															{rateValue} از 5
														</span>
													</Box>}
													{!checkUserIsLogin() && !isRating && <Box className="rateMessage">
														<p>برای ثبت امتیاز ابتدا وارد شوید</p>
														{goToRegister()}
													</Box>}
												</Box>
											</div>
										</div>
									</div>
									<div className="left">
										<div className='d-flex w-100'>
											<div className='top-content'>
												<h2 className='title'>
													{movieDetail?.baseDetails.title}
												</h2>
												<div className='english-title'>
													{movieDetail?.baseDetails.englishTitle}
												</div>
												{renderGenres(movieDetail?.metadata.genres)}
												{movieDetail?.metadata.movieLength && <div className="movie-length">
													<ImageGenerator src={time}
																	isLazy={false}
																	name={''} />
													{movieDetail?.metadata.movieLength}
												</div>}

												{
													movieDetail?.metadata.ageRate && <div className="ageRate"
																						  dangerouslySetInnerHTML={{ __html: ageRate(movieDetail?.metadata.ageRate) }}>
													</div>
												}
											</div>
											<div className='top-meta'>
												<div className="d-flex">
													<div className="dark-bg">
														{renderImdbRate()}
													</div>
													<div className="dark-bg">
														{rateUsers()}
													</div>
												</div>
												<div className="meta-other">
													{
														valueMovie?.metadata?.isDubbed ? (
															<div>
																<ImageGenerator src={voice}
																				isLazy={false}
																				name={''} />
																<span>
																	دوبله شده
																</span>
															</div>
														) : valueMovie?.metadata?.hasSubtitle ? (
															<div>
																<ImageGenerator src={subTitle}
																				isLazy={false}
																				name={''} />
																<span>
																زیرنویس
															</span>
															</div>
														) : null
													}
													<div>
														<div>
															{valueMovie?.metadata?.productionYear}
														</div>
														<span>
													{valueMovie?.metadata?.countries?.map((item) => item).join(' - ')}
												</span>
													</div>
												</div>
											</div>
										</div>

										<div className="d-flex" style={{marginTop: '10px'}}>
											<div style={{width: '18px', marginLeft: '15px', cursor: 'pointer'}} onClick={() => {
												setShareDialog(true);
											}}>
												<ImageGenerator src={share} />
											</div>
											<div style={{width: '18px', cursor: 'pointer'}}
												 className={movieDetail?.userInteractions?.isFavorite ? 'added' : 'unAdded'}
												 onClick={handleAddToFav}>
												<ImageGenerator src={favListAdd} />
											</div>
										</div>

										<p className="description">
											{movieDetail?.baseDetails.description}
										</p>
										<div className="handler">
											{handleStatus()}
											<div style={{position: 'relative', marginRight: '24px'}}>
												{typeProgram === 'SERIES' ? (
													<Button variant={'text'}  onClick={()=> {
														const element = document.querySelector('.download-box-entry');
														element.scrollIntoView({ behavior: 'smooth', block: 'start' });
													}}
															className="play">
														<div className='download-handler'>
															<ImageGenerator src={download}
																			isLazy={false}
																			name={''}/>
															دانلود
														</div>
													</Button>
													) : (
														<Button variant={'text'} onClick={() => {
															setShowBoxDownload(!showBoxDownload)
														}} className="play">
															<div className={`download-handler${showBoxDownload ? ' show': ''}`}>
																<ImageGenerator src={download}
																				isLazy={false}
																				name={''} />
																دانلود
																<div className="arrow-down">
																	<ImageGenerator src={arrowDown}
																					isLazy={false}
																					name={''} />
																</div>
															</div>
														</Button>
													)
												}


												{showBoxDownload && <div className="download-box-details">
													{downloadLinks.map((row) => (
														<div key={row.size}>
															<a href={row.link} target="_blank"
															   className="qualities"
															   key={row.size}>
																<p className="Allqualities">
																	{row.size}
																</p>
																<ImageGenerator src={download}
																				isLazy={false}
																				name={''} />
															</a>
														</div>

													))}
												</div>}
											</div>
										</div>


									</div>
								</div>
							</div>
						</div>
					</div>
				</> : null}
			</div>
			<Dialog onClose={() => {
				setShareDialog(false)
			}}
					open={shareDialog}>
				<ShareBottomSheet type={typeProgram === 'MOVIE' ? 'movies' : 'series'} data={movieDetail} />
			</Dialog>
			<Toast toastList={toastData}
				   position={'top-right'}
				   autoDelete={false}
				   dismissTime={3000} />
			<AuthenticationDialogHandler openRegisterDialog={openRegisterDialog}
										 setOpenRegisterDialog={setOpenRegisterDialog} />
		</>
	);
}
